import React, { Component } from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import classNames from 'classnames';
import './TableStatusTag.css';
import { IconLoader } from 'common/IconLoader';

export class TableStatusTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };
  }

  render() {
    let classname = '';
    switch (this.props.status) {
      case 'Success':
        classname = 'TableStatusTag_Success';
        break;
      case 'Failed':
        classname = 'TableStatusTag_Failed';
        break;
      case 'Revert all':
        classname = 'TableStatusTag_RevertAll';
        break;
      default:
        break;
    }

    return (
      <div
        className={'TableStatusTag_Div ' + classname}
        onMouseEnter={() => {
          this.setState({ hovered: true });
        }}
        onMouseLeave={() => {
          this.setState({ hovered: false });
        }}
        onClick={this.props.onClickHandler}
      >
        <div
          className={classNames({
            ['TableStatusTag_Box ' + classname]: true,
            TableStatusTag_Hovered: this.state.hovered
          })}
        >
          <div className="TableStatusTag_Text">{this.props.status} </div>
        </div>
        <div
          className={classNames({
            ['TableStatusTag_Icon_Div ' + classname]: true,
            TableStatusTag_Hovered: this.state.hovered
          })}
        >
          <SvgAF
            img={IconLoader.icon_revert}
            hover={IconLoader.icon_revert_hover}
            forceHover={this.state.hovered}
            log
          />
        </div>
      </div>
    );
  }
}
